import { render, staticRenderFns } from "./Automation.vue?vue&type=template&id=07029293&"
import script from "./Automation.vue?vue&type=script&lang=js&"
export * from "./Automation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports